import * as React from "react";
import { Text } from "@blueprintjs/core";
import styled from "styled-components";
import type { ComponentProps } from "widgets/BaseComponent";
import Interweave from "interweave";
import { UrlMatcher, EmailMatcher } from "interweave-autolink";
import type { TextSize } from "constants/WidgetConstants";
import { DEFAULT_FONT_SIZE, FontStyleTypes } from "constants/WidgetConstants";
import { Icon, IconSize } from "@design-system/widgets-old";
import { get } from "lodash";
import equal from "fast-deep-equal/es6";
import ModalComponent from "components/designSystems/appsmith/ModalComponent";
import type { Color } from "constants/Colors";
import { Colors } from "constants/Colors";
import { fontSizeUtility, subStringText } from "widgets/WidgetUtils";
import { OverflowTypes } from "../constants";
import moment from "moment";
import _ from "lodash";




export const DivContainer = styled.div<{
  numDecimal?: number,
  defaultCount?: number,
  maxCount?: number,
  isFixed?: Boolean;
  numFixed?: number,
  time?: number,
  step?: number,
  fontFamily?: string;
  fontSize?: string;
  fontStyle?: string;
  widthPadding?: number,
  widthBorderRadius?: string;
  textColor?: string;
  backgroundColor?: string;
  borderWidth?: string;
  borderRadius?: string;
  boxShadow?: string;
}>`
& {
  height: 100%;
  width: 100%;
  position: relative;
}
.z-container {
  display: flex;
  /* 使用 Flexbox 布局 */
  justify-content: center;
  /* 子元素等间距排列 */
  align-items: stretch;
  /* 垂直居中对齐 */
  /* 容器内边距 */
  width: 100%;
  height:100%;
  background-color: transparent;
}

.card {
  flex-grow:1;
  /* 卡片宽度 */
  height: 100%;
  /* 卡片高度 */
  background-color: ${(props) => props?.backgroundColor};
  /* 卡片背景颜色 */
  text-align: center;
  /* 文本居中 */
  /* 行高与卡片高度相同，使文本垂直居中 */
  border-radius:${(props) => props?.widthBorderRadius}px;
  /* 卡片圆角 */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  /* 卡片阴影 */
  margin:0px ${(props) => props?.widthPadding}px;
  max-width:50px;
}

.card-number {
  height: 100%;
  font-size: ${({ fontSize }) =>
    fontSizeUtility(fontSize) || DEFAULT_FONT_SIZE};
  /* 数字字体大小 */
  font-style: ${({ fontStyle }) => fontStyle?.includes(FontStyleTypes.ITALIC) ? "italic" : ""}  !important;
  font-weight: ${({ fontStyle }) => fontStyle?.includes(FontStyleTypes.BOLD) ? "BOLD" : ""}  !important;
  color: ${(props) => props?.textColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${({fontFamily})=>fontFamily};
  /* 数字字体加粗 */
}
`;


type StyledTextProps = React.PropsWithChildren<{
  isDecimal?: number,
  numDecimal?: number,
  defaultCount?: number,
  maxCount?: number,
  isFixed?: Boolean;
  numFixed?: number,
  time?: number,
  step?: number,
  fontFamily?: string,
  fontSize?: string,
  fontStyle?: string,
  widthPadding?: number,
  widthBorderRadius?: string,
  textColor?: string,
  backgroundColor?: string,
  borderWidth?: string,
  borderRadius?: string,
  boxShadow?: string
}>;

export const StyledText = styled(Text) <StyledTextProps>`
`;

export interface TextComponentProps extends ComponentProps {
  isDecimal?: boolean,
  numDecimal?: number,
  defaultCount?: number,
  maxCount?: number,
  isFixed?: Boolean;//位数是否固定
  numFixed?: number,//位数
  time?: number,
  step?: number,
  fontFamily?: string;
  fontSize?: string;
  fontStyle?: string;
  widthPadding?: number,
  widthBorderRadius?: string;
  textColor?: string;
  backgroundColor?: string;
  borderWidth?: string;
  borderRadius?: string;
  boxShadow?: string;
}

class TextComponent extends React.Component<TextComponentProps, State> {
  timer: any;
  constructor(props: any) {
    super(props);
    this.state = {
      count: this.props.defaultCount,
      interval:Math.max( Math.floor(this.props.time / this.props.step), 10),  
      maxCount: props.maxCount, 
      increment: Math.abs(this.props.defaultCount -this.props. maxCount) / this.props.step,
    };
  }

  componentDidMount() {
    if(this.props.defaultCount!== this.props.maxCount&&(this.props.value==null||this.props.value=="")){
      this.timer = setInterval(this.incrementCount, this.state.interval);
    }
  }

  componentWillUnmount() {
    if(this.timer){
      clearInterval(this.timer);
    }
  }

  endTask=()=>{
    this.setState((prevState: any) => ({
      count: this.state.maxCount
    }));
    clearInterval(this.timer);
  }
  incrementCount = () => {
    const {isDecimal,numDecimal} = this.props;
    const { count, maxCount,increment } = this.state;
    const _defaultCount:any=this.props.defaultCount;
    let _increment=increment;
    if (_defaultCount < maxCount) {
      if (count < maxCount) {
        if(count+_increment>=maxCount){
          this.setState((prevState: any) => ({
            count: maxCount,
          }));
        }
        else{
          this.setState((prevState: any) => ({
            count:isDecimal?parseFloat((prevState.count + _increment).toFixed(numDecimal)):parseInt(prevState.count + _increment),
          }));
        }
      } else {
        this.endTask();
      }
    }
    if (_defaultCount > maxCount) {
      if (count > maxCount) {
        if(count-_increment<=maxCount){
          this.setState((prevState: any) => ({
            count: maxCount,
          }));
        }
        else{
          this.setState((prevState: any) => ({
            count:isDecimal?parseFloat((prevState.count - _increment).toFixed(numDecimal)): parseInt(prevState.count - _increment),
          }));
        }
        
      } else {
        this.endTask();
      }
    }
  };

  render() {
    const {
      value,
      isDecimal,
      numDecimal,
      defaultCount,
      maxCount,
      isFixed,
      numFixed,
      time,
      step,
      fontFamily,
      fontSize,
      fontStyle,
      widthPadding,
      widthBorderRadius,
      textColor,
      backgroundColor,
      borderWidth,
      borderRadius,
      boxShadow
    } = this.props;
    let _count=(value==null||value=="")?this.state.count:value;
    let count=isDecimal?_count.toFixed(numDecimal):_count;
    const padNumber = (num: any, length: any) => {
      return String(num).padStart(length, '0');
    }
    const strCount =isFixed? padNumber(count, numFixed):String(count);
    return (
      <>
        <DivContainer
          numDecimal={numDecimal}
          defaultCount={defaultCount}
          maxCount={maxCount}
          isFixed={isFixed}
          numFixed={numFixed}
          time={time}
          step={step}
          fontFamily={fontFamily}
          fontSize={fontSize}
          fontStyle={fontStyle}
          widthPadding={widthPadding}
          widthBorderRadius={widthBorderRadius}
          textColor={textColor}
          backgroundColor={backgroundColor}
          borderWidth={borderWidth}
          borderRadius={borderRadius}
          boxShadow={boxShadow}
        >
          <div className="z-container">
            {
              strCount.split('').map((char, index) => (
                <div className="card">
                  <div key={index} className="card-number">
                    {char}
                  </div>
                </div>
              ))
            }
          </div>
        </DivContainer>

      </>
    );
  }
}

export default TextComponent;
